"use client";

import styled from "styled-components";
import { Switch } from "@/components/ui/switch";

export const SwitchStyled = styled(Switch)`
  transition: all 0.2s ease-out;
  cursor: pointer;

  /* Use cor neutra para estado unchecked para evitar aparência de erro */
  &[data-state="unchecked"] {
    background-color: var(--input) !important;
  }

  /* Verde para estado checked */
  &[data-state="checked"] {
    background-color: var(--green) !important;
  }

  span {
    transition: all 0.3s ease-out;
  }
`;
